unit dashboard.loads.controller;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, WEBLib.ExtCtrls, Vcl.Controls, Data.DB,
  WEBLib.DB, XData.Web.JsonDataset, XData.Web.Dataset, XData.Web.Client,
  VCL.TMSFNCTypes, VCL.TMSFNCUtils, VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes,
  System.Rtti, VCL.TMSFNCDataGridCell, VCL.TMSFNCDataGridData,
  VCL.TMSFNCDataGridBase, VCL.TMSFNCDataGridCore, VCL.TMSFNCDataGridRenderer,
  VCL.TMSFNCCustomComponent, VCL.TMSFNCDataGridDatabaseAdapter,
  VCL.TMSFNCCustomControl, VCL.TMSFNCDataGrid, Vcl.StdCtrls, VCL.TMSFNCButton,
  WEBLib.StdCtrls, WEBLib.DBCtrls;

type
  TfrmDashboardControllers = class(TForm)
    wpTop: TPanel;
    WebScrollBox1: TScrollBox;
    wpInformation: TPanel;
    wpController: TPanel;
    wcController: TXDataWebClient;
    wdsController: TXDataWebDataSet;
    dsController: TDataSource;
    wdsControllerController: TStringField;
    wdsControllerTotalLoads: TIntegerField;
    wdsControllerRevenue: TFloatField;
    TMSFNCDataGrid1: TTMSFNCDataGrid;
    TMSFNCDataGridDatabaseAdapter1: TTMSFNCDataGridDatabaseAdapter;
    TMSFNCButton1: TTMSFNCButton;
    TMSFNCDataGrid2: TTMSFNCDataGrid;
    wcDetails: TXDataWebClient;
    wdsDetails: TXDataWebDataSet;
    StringField1: TStringField;
    dsDetails: TDataSource;
    TMSFNCDataGridDatabaseAdapter2: TTMSFNCDataGridDatabaseAdapter;
    wdsControllerConKey: TStringField;
    wdsDetailsConKey: TStringField;
    wdsDetailsLoadconNo: TIntegerField;
    wdsDetailsRegNo: TStringField;
    wdsDetailsContractNo: TIntegerField;
    wdsDetailsContractName: TStringField;
    wdsDetailsRevenue: TFloatField;
    DataSource1: TDataSource;
    wdsDetailsLoadeddate: TStringField;
    procedure TMSFNCButton1Click(Sender: TObject);
    procedure TMSFNCDataGrid1CellClick(Sender: TObject; AColumn, ARow: Integer);
  private
    { Private declarations }
    procedure LoadDetailData;
  public
    { Public declarations }
    iYear,
    iMonth,
    iCompany : Integer;
    procedure LoadData;
  protected procedure LoadDFMValues; override; end;

var
  frmDashboardControllers: TfrmDashboardControllers;

implementation

{$R *.dfm}

uses
  stfmssystem.connection,
  share.common,
  share.classes;
{ TfrmDashboardControllers }

procedure TfrmDashboardControllers.LoadData;
  procedure OnError(Error: TXDataClientError);
  begin
    LoadData;
  end;
  procedure OnResult(Response : TXDataClientResponse);
  begin
    If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
      begin
        LoadData;
      end
    else
      begin
        wdsController.Close;
        wdsController.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
        wdsController.Open;
      end;

    Case iMonth of
      1 : begin
            if iCompany = 1 then
              wpInformation.Caption := 'OWN FLEET - JANUARY ' + IntToStr(iYear)
            else
              wpInformation.Caption := 'SUBS FLEET - JANUARY ' + IntToStr(iYear);
          end;
      2 : begin
            if iCompany = 1 then
              wpInformation.Caption := 'OWN FLEET - FEBRUARY ' + IntToStr(iYear)
            else
              wpInformation.Caption := 'SUBS FLEET - FEBRUARY ' + IntToStr(iYear);
          end;
      3 : begin
            if iCompany = 1 then
              wpInformation.Caption := 'OWN FLEET - MARCH ' + IntToStr(iYear)
            else
              wpInformation.Caption := 'SUBS FLEET - MARCH ' + IntToStr(iYear);
          end;
      4 : begin
            if iCompany = 1 then
              wpInformation.Caption := 'OWN FLEET - APRIL ' + IntToStr(iYear)
            else
              wpInformation.Caption := 'SUBS FLEET - APRIL ' + IntToStr(iYear);
          end;
      5 : begin
            if iCompany = 1 then
              wpInformation.Caption := 'OWN FLEET - MAY ' + IntToStr(iYear)
            else
              wpInformation.Caption := 'SUBS FLEET - MAY ' + IntToStr(iYear);
          end;
      6 : begin
            if iCompany = 1 then
              wpInformation.Caption := 'OWN FLEET - JUNE ' + IntToStr(iYear)
            else
              wpInformation.Caption := 'SUBS FLEET - JUNE ' + IntToStr(iYear);
          end;
      7 : begin
            if iCompany = 1 then
              wpInformation.Caption := 'OWN FLEET - JULY ' + IntToStr(iYear)
            else
              wpInformation.Caption := 'SUBS FLEET - JULY ' + IntToStr(iYear);
          end;
      8 : begin
            if iCompany = 1 then
              wpInformation.Caption := 'OWN FLEET - AUGUST ' + IntToStr(iYear)
            else
              wpInformation.Caption := 'SUBS FLEET - AUGUST ' + IntToStr(iYear);
          end;
      9 : begin
            if iCompany = 1 then
              wpInformation.Caption := 'OWN FLEET - SEPTEMBER ' + IntToStr(iYear)
            else
              wpInformation.Caption := 'SUBS FLEET - SEPTEMBER ' + IntToStr(iYear);
          end;
      10 : begin
            if iCompany = 1 then
              wpInformation.Caption := 'OWN FLEET - OCTOBER ' + IntToStr(iYear)
            else
              wpInformation.Caption := 'SUBS FLEET - OCTOBER ' + IntToStr(iYear);
           end;
      11 : begin
            if iCompany = 1 then
              wpInformation.Caption := 'OWN FLEET - NOVEMBER ' + IntToStr(iYear)
            else
              wpInformation.Caption := 'SUBS FLEET - NOVEMBER ' + IntToStr(iYear);
           end;
      12 : begin
            if iCompany = 1 then
              wpInformation.Caption := 'OWN FLEET - DECEMBER ' + IntToStr(iYear)
            else
              wpInformation.Caption := 'SUBS FLEET - DECEMBER ' + IntToStr(iYear);
           end;
    End;
  end;

begin
  wcController.RawInvoke('IdashboardService.GetLoadsControllers', [iMonth,iYear,iCompany], @OnResult, @OnError);
end;

procedure TfrmDashboardControllers.LoadDetailData;
  procedure OnError(Error: TXDataClientError);
  begin
    LoadDetailData;
  end;
  procedure OnResult(Response : TXDataClientResponse);
  begin
    If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
      begin
        LoadDetailData;
      end
    else
      begin
        wdsDetails.Close;
        wdsDetails.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
        wdsDetails.Open;
      end;
  end;

begin
  wcDetails.RawInvoke('IdashboardService.GetLoadsControllerDetails', [iMonth,iYear,iCompany,wdsController.FieldByName('ConKey').asString], @OnResult, @OnError);
end;

procedure TfrmDashboardControllers.TMSFNCButton1Click(Sender: TObject);
begin
  Close;
end;

procedure TfrmDashboardControllers.TMSFNCDataGrid1CellClick(Sender: TObject;
  AColumn, ARow: Integer);
begin
  LoadDetailData;
end;

procedure TfrmDashboardControllers.LoadDFMValues;
begin
  inherited LoadDFMValues;

  wpTop := TPanel.Create(Self);
  WebScrollBox1 := TScrollBox.Create(Self);
  wpInformation := TPanel.Create(Self);
  TMSFNCButton1 := TTMSFNCButton.Create(Self);
  wpController := TPanel.Create(Self);
  TMSFNCDataGrid1 := TTMSFNCDataGrid.Create(Self);
  TMSFNCDataGridDatabaseAdapter1 := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  TMSFNCDataGrid2 := TTMSFNCDataGrid.Create(Self);
  TMSFNCDataGridDatabaseAdapter2 := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  wcController := TXDataWebClient.Create(Self);
  wdsController := TXDataWebDataSet.Create(Self);
  wdsControllerController := TStringField.Create(Self);
  wdsControllerTotalLoads := TIntegerField.Create(Self);
  wdsControllerRevenue := TFloatField.Create(Self);
  wdsControllerConKey := TStringField.Create(Self);
  dsController := TDataSource.Create(Self);
  wcDetails := TXDataWebClient.Create(Self);
  wdsDetails := TXDataWebDataSet.Create(Self);
  StringField1 := TStringField.Create(Self);
  wdsDetailsConKey := TStringField.Create(Self);
  wdsDetailsLoadconNo := TIntegerField.Create(Self);
  wdsDetailsRegNo := TStringField.Create(Self);
  wdsDetailsContractNo := TIntegerField.Create(Self);
  wdsDetailsContractName := TStringField.Create(Self);
  wdsDetailsRevenue := TFloatField.Create(Self);
  wdsDetailsLoadeddate := TStringField.Create(Self);
  dsDetails := TDataSource.Create(Self);
  DataSource1 := TDataSource.Create(Self);

  wpTop.BeforeLoadDFMValues;
  WebScrollBox1.BeforeLoadDFMValues;
  wpInformation.BeforeLoadDFMValues;
  TMSFNCButton1.BeforeLoadDFMValues;
  wpController.BeforeLoadDFMValues;
  TMSFNCDataGrid1.BeforeLoadDFMValues;
  TMSFNCDataGridDatabaseAdapter1.BeforeLoadDFMValues;
  TMSFNCDataGrid2.BeforeLoadDFMValues;
  TMSFNCDataGridDatabaseAdapter2.BeforeLoadDFMValues;
  wcController.BeforeLoadDFMValues;
  wdsController.BeforeLoadDFMValues;
  wdsControllerController.BeforeLoadDFMValues;
  wdsControllerTotalLoads.BeforeLoadDFMValues;
  wdsControllerRevenue.BeforeLoadDFMValues;
  wdsControllerConKey.BeforeLoadDFMValues;
  dsController.BeforeLoadDFMValues;
  wcDetails.BeforeLoadDFMValues;
  wdsDetails.BeforeLoadDFMValues;
  StringField1.BeforeLoadDFMValues;
  wdsDetailsConKey.BeforeLoadDFMValues;
  wdsDetailsLoadconNo.BeforeLoadDFMValues;
  wdsDetailsRegNo.BeforeLoadDFMValues;
  wdsDetailsContractNo.BeforeLoadDFMValues;
  wdsDetailsContractName.BeforeLoadDFMValues;
  wdsDetailsRevenue.BeforeLoadDFMValues;
  wdsDetailsLoadeddate.BeforeLoadDFMValues;
  dsDetails.BeforeLoadDFMValues;
  DataSource1.BeforeLoadDFMValues;
  try
    Name := 'frmDashboardControllers';
    Width := 1180;
    Height := 591;
    Align := alClient;
    wpTop.SetParentComponent(Self);
    wpTop.Name := 'wpTop';
    wpTop.Left := 0;
    wpTop.Top := 0;
    wpTop.Width := 1180;
    wpTop.Height := 41;
    wpTop.Align := alTop;
    wpTop.Caption := 'Loads Dashboard Controllers';
    wpTop.Font.Charset := DEFAULT_CHARSET;
    wpTop.Font.Color := clWindowText;
    wpTop.Font.Height := -12;
    wpTop.Font.Name := 'Segoe UI';
    wpTop.Font.Style := [fsBold];
    wpTop.ParentFont := False;
    wpTop.TabOrder := 0;
    WebScrollBox1.SetParentComponent(Self);
    WebScrollBox1.Name := 'WebScrollBox1';
    WebScrollBox1.Left := 0;
    WebScrollBox1.Top := 41;
    WebScrollBox1.Width := 1180;
    WebScrollBox1.Height := 550;
    WebScrollBox1.Align := alClient;
    WebScrollBox1.BorderStyle := bsSingle;
    WebScrollBox1.ChildOrder := 1;
    wpInformation.SetParentComponent(WebScrollBox1);
    wpInformation.Name := 'wpInformation';
    wpInformation.Left := 0;
    wpInformation.Top := 0;
    wpInformation.Width := 1180;
    wpInformation.Height := 60;
    wpInformation.Align := alTop;
    wpInformation.Caption := 'wpInformation';
    wpInformation.Font.Charset := DEFAULT_CHARSET;
    wpInformation.Font.Color := clWindowText;
    wpInformation.Font.Height := -12;
    wpInformation.Font.Name := 'Segoe UI';
    wpInformation.Font.Style := [fsBold];
    wpInformation.ParentFont := False;
    wpInformation.TabOrder := 0;
    TMSFNCButton1.SetParentComponent(wpInformation);
    TMSFNCButton1.Name := 'TMSFNCButton1';
    TMSFNCButton1.Left := 32;
    TMSFNCButton1.Top := 16;
    TMSFNCButton1.Width := 100;
    TMSFNCButton1.Height := 25;
    TMSFNCButton1.Font.Charset := DEFAULT_CHARSET;
    TMSFNCButton1.Font.Color := clWindowText;
    TMSFNCButton1.Font.Height := -12;
    TMSFNCButton1.Font.Name := 'Segoe UI';
    TMSFNCButton1.Font.Style := [];
    TMSFNCButton1.Text := 'Back';
    TMSFNCButton1.TabOrder := 0;
    SetEvent(TMSFNCButton1, Self, 'OnClick', 'TMSFNCButton1Click');
    wpController.SetParentComponent(WebScrollBox1);
    wpController.Name := 'wpController';
    wpController.Left := 0;
    wpController.Top := 60;
    wpController.Width := 497;
    wpController.Height := 490;
    wpController.Align := alLeft;
    wpController.ChildOrder := 1;
    wpController.TabOrder := 1;
    TMSFNCDataGrid1.SetParentComponent(wpController);
    TMSFNCDataGrid1.Name := 'TMSFNCDataGrid1';
    TMSFNCDataGrid1.Left := 0;
    TMSFNCDataGrid1.Top := 0;
    TMSFNCDataGrid1.Width := 497;
    TMSFNCDataGrid1.Height := 490;
    TMSFNCDataGrid1.Align := alClient;
    TMSFNCDataGrid1.ParentDoubleBuffered := False;
    TMSFNCDataGrid1.DoubleBuffered := True;
    TMSFNCDataGrid1.TabOrder := 0;
    TMSFNCDataGrid1.Adapter := TMSFNCDataGridDatabaseAdapter1;
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Style := [];
    TMSFNCDataGrid1.ColumnCount := 3;
    TMSFNCDataGrid1.Columns.Clear;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      ReadOnly := True;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Controller';
      Settings := [gcsReadOnly];
      Width := 250.000000000000000000;
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      ReadOnly := True;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.BandLayout.TextAlign := gtaTrailing;
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedLayout.TextAlign := gtaTrailing;
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.NormalLayout.TextAlign := gtaTrailing;
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      ControlAlign := gcaRight;
      Header := 'Loads';
      Settings := [gcsAppearance,gcsReadOnly,gcsControlAlign];
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      ReadOnly := True;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedLayout.TextAlign := gtaTrailing;
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.NormalLayout.TextAlign := gtaTrailing;
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      ControlAlign := gcaRight;
      Formatting.&Type := gdftFloat;
      Formatting.Format := '#,##0.00';
      Header := 'Revenue';
      Settings := [gcsAppearance,gcsReadOnly,gcsFormatting,gcsControlAlign];
      Width := 150.000000000000000000;
    end;
    TMSFNCDataGrid1.Designer := False;
    TMSFNCDataGrid1.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.FilterAppearance.Font.Color := clWindowText;
    TMSFNCDataGrid1.FilterAppearance.Font.Height := -12;
    TMSFNCDataGrid1.FilterAppearance.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.FilterAppearance.Font.Style := [];
    TMSFNCDataGrid1.Icons.ExpandIcon.LoadFromFile('dashboard.loads.controller.wpController.TMSFNCDataGrid1.Icons.ExpandIcon.svg');
    TMSFNCDataGrid1.Icons.CollapseIcon.LoadFromFile('dashboard.loads.controller.wpController.TMSFNCDataGrid1.Icons.CollapseIcon.svg');
    TMSFNCDataGrid1.Icons.FilterIcon.LoadFromFile('dashboard.loads.controller.wpController.TMSFNCDataGrid1.Icons.FilterIcon.svg');
    TMSFNCDataGrid1.Icons.FilterActiveIcon.LoadFromFile('dashboard.loads.controller.wpController.TMSFNCDataGrid1.Icons.FilterActiveIcon.svg');
    TMSFNCDataGrid1.Icons.FilterClearIcon.LoadFromFile('dashboard.loads.controller.wpController.TMSFNCDataGrid1.Icons.FilterClearIcon.svg');
    TMSFNCDataGrid1.Icons.FilterTypeIcon.LoadFromFile('dashboard.loads.controller.wpController.TMSFNCDataGrid1.Icons.FilterTypeIcon.svg');
    TMSFNCDataGrid1.Icons.SortAscendingIcon.LoadFromFile('dashboard.loads.controller.wpController.TMSFNCDataGrid1.Icons.SortAscendingIcon.svg');
    TMSFNCDataGrid1.Icons.SortDescendingIcon.LoadFromFile('dashboard.loads.controller.wpController.TMSFNCDataGrid1.Icons.SortDescendingIcon.svg');
    SetEvent(TMSFNCDataGrid1, Self, 'OnCellClick', 'TMSFNCDataGrid1CellClick');
    TMSFNCDataGrid1.Options.Filtering.Advanced := False;
    TMSFNCDataGrid1.Options.Sorting.Enabled := True;
    TMSFNCDataGrid1.RowCount := 1;
    TMSFNCDataGrid1.Stroke.Color := clDarkgray;
    TMSFNCDataGridDatabaseAdapter1.SetParentComponent(TMSFNCDataGrid1);
    TMSFNCDataGridDatabaseAdapter1.Name := 'TMSFNCDataGridDatabaseAdapter1';
    TMSFNCDataGridDatabaseAdapter1.Left := 152;
    TMSFNCDataGridDatabaseAdapter1.Top := 64;
    TMSFNCDataGridDatabaseAdapter1.Width := 26;
    TMSFNCDataGridDatabaseAdapter1.Height := 26;
    TMSFNCDataGridDatabaseAdapter1.Visible := True;
    TMSFNCDataGridDatabaseAdapter1.AutoCreateColumns := False;
    TMSFNCDataGridDatabaseAdapter1.AutoRemoveColumns := False;
    TMSFNCDataGridDatabaseAdapter1.Columns.Clear;
    with TMSFNCDataGridDatabaseAdapter1.Columns.Add do
    begin
      FieldName := 'Controller';
      Header := 'Controller';
      AutoCreated := False;
    end;
    with TMSFNCDataGridDatabaseAdapter1.Columns.Add do
    begin
      FieldName := 'TotalLoads';
      Header := 'Loads';
      AutoCreated := False;
    end;
    with TMSFNCDataGridDatabaseAdapter1.Columns.Add do
    begin
      FieldName := 'Revenue';
      Header := 'Revenue';
      AutoCreated := False;
    end;
    TMSFNCDataGridDatabaseAdapter1.DataSource := dsController;
    TMSFNCDataGridDatabaseAdapter1.LoadMode := almAllRecords;
    TMSFNCDataGrid2.SetParentComponent(WebScrollBox1);
    TMSFNCDataGrid2.Name := 'TMSFNCDataGrid2';
    TMSFNCDataGrid2.Left := 497;
    TMSFNCDataGrid2.Top := 60;
    TMSFNCDataGrid2.Width := 683;
    TMSFNCDataGrid2.Height := 490;
    TMSFNCDataGrid2.Align := alClient;
    TMSFNCDataGrid2.ParentDoubleBuffered := False;
    TMSFNCDataGrid2.DoubleBuffered := True;
    TMSFNCDataGrid2.TabOrder := 2;
    TMSFNCDataGrid2.Adapter := TMSFNCDataGridDatabaseAdapter2;
    TMSFNCDataGrid2.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid2.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    TMSFNCDataGrid2.CellAppearance.FilterMatchLayout.Font.Height := -12;
    TMSFNCDataGrid2.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid2.CellAppearance.FilterMatchLayout.Font.Style := [];
    TMSFNCDataGrid2.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid2.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    TMSFNCDataGrid2.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    TMSFNCDataGrid2.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid2.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    TMSFNCDataGrid2.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid2.CellAppearance.BandLayout.Font.Color := clWindowText;
    TMSFNCDataGrid2.CellAppearance.BandLayout.Font.Height := -12;
    TMSFNCDataGrid2.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid2.CellAppearance.BandLayout.Font.Style := [];
    TMSFNCDataGrid2.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid2.CellAppearance.FixedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid2.CellAppearance.FixedLayout.Font.Height := -12;
    TMSFNCDataGrid2.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid2.CellAppearance.FixedLayout.Font.Style := [];
    TMSFNCDataGrid2.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid2.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid2.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    TMSFNCDataGrid2.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid2.CellAppearance.FixedSelectedLayout.Font.Style := [];
    TMSFNCDataGrid2.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid2.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid2.CellAppearance.FocusedLayout.Font.Height := -12;
    TMSFNCDataGrid2.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid2.CellAppearance.FocusedLayout.Font.Style := [];
    TMSFNCDataGrid2.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid2.CellAppearance.GroupLayout.Font.Color := clWindowText;
    TMSFNCDataGrid2.CellAppearance.GroupLayout.Font.Height := -12;
    TMSFNCDataGrid2.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid2.CellAppearance.GroupLayout.Font.Style := [];
    TMSFNCDataGrid2.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid2.CellAppearance.NormalLayout.Font.Color := clWindowText;
    TMSFNCDataGrid2.CellAppearance.NormalLayout.Font.Height := -12;
    TMSFNCDataGrid2.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid2.CellAppearance.NormalLayout.Font.Style := [];
    TMSFNCDataGrid2.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid2.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid2.CellAppearance.SelectedLayout.Font.Height := -12;
    TMSFNCDataGrid2.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid2.CellAppearance.SelectedLayout.Font.Style := [];
    TMSFNCDataGrid2.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid2.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    TMSFNCDataGrid2.CellAppearance.SummaryLayout.Font.Height := -12;
    TMSFNCDataGrid2.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid2.CellAppearance.SummaryLayout.Font.Style := [];
    TMSFNCDataGrid2.ColumnCount := 5;
    TMSFNCDataGrid2.Columns.Clear;
    with TMSFNCDataGrid2.Columns.Add do
    begin
      ReadOnly := True;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Loaded Date';
      Settings := [gcsEditor,gcsFormatting];
      Width := 95.000000000000000000;
    end;
    with TMSFNCDataGrid2.Columns.Add do
    begin
      ReadOnly := True;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Formatting.&Type := gdftNumber;
      Header := 'Loadcon No';
      Settings := [gcsReadOnly,gcsFormatting];
      Width := 85.000000000000000000;
    end;
    with TMSFNCDataGrid2.Columns.Add do
    begin
      ReadOnly := True;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Reg No';
      Settings := [gcsReadOnly];
      Width := 95.000000000000000000;
    end;
    with TMSFNCDataGrid2.Columns.Add do
    begin
      ReadOnly := True;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Contract';
      Settings := [gcsReadOnly];
      Width := 250.000000000000000000;
    end;
    with TMSFNCDataGrid2.Columns.Add do
    begin
      ReadOnly := True;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.BandLayout.TextAlign := gtaTrailing;
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedLayout.TextAlign := gtaTrailing;
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.TextAlign := gtaTrailing;
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.NormalLayout.TextAlign := gtaTrailing;
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Formatting.&Type := gdftFloat;
      Formatting.Format := '#,##0.00';
      Header := 'Revenue';
      Settings := [gcsAppearance,gcsReadOnly,gcsFormatting];
      Width := 125.000000000000000000;
    end;
    TMSFNCDataGrid2.Designer := False;
    TMSFNCDataGrid2.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid2.FilterAppearance.Font.Color := clWindowText;
    TMSFNCDataGrid2.FilterAppearance.Font.Height := -12;
    TMSFNCDataGrid2.FilterAppearance.Font.Name := 'Segoe UI';
    TMSFNCDataGrid2.FilterAppearance.Font.Style := [];
    TMSFNCDataGrid2.Icons.ExpandIcon.LoadFromFile('dashboard.loads.controller.WebScrollBox1.TMSFNCDataGrid2.Icons.ExpandIcon.svg');
    TMSFNCDataGrid2.Icons.CollapseIcon.LoadFromFile('dashboard.loads.controller.WebScrollBox1.TMSFNCDataGrid2.Icons.CollapseIcon.svg');
    TMSFNCDataGrid2.Icons.FilterIcon.LoadFromFile('dashboard.loads.controller.WebScrollBox1.TMSFNCDataGrid2.Icons.FilterIcon.svg');
    TMSFNCDataGrid2.Icons.FilterActiveIcon.LoadFromFile('dashboard.loads.controller.WebScrollBox1.TMSFNCDataGrid2.Icons.FilterActiveIcon.svg');
    TMSFNCDataGrid2.Icons.FilterClearIcon.LoadFromFile('dashboard.loads.controller.WebScrollBox1.TMSFNCDataGrid2.Icons.FilterClearIcon.svg');
    TMSFNCDataGrid2.Icons.FilterTypeIcon.LoadFromFile('dashboard.loads.controller.WebScrollBox1.TMSFNCDataGrid2.Icons.FilterTypeIcon.svg');
    TMSFNCDataGrid2.Icons.SortAscendingIcon.LoadFromFile('dashboard.loads.controller.WebScrollBox1.TMSFNCDataGrid2.Icons.SortAscendingIcon.svg');
    TMSFNCDataGrid2.Icons.SortDescendingIcon.LoadFromFile('dashboard.loads.controller.WebScrollBox1.TMSFNCDataGrid2.Icons.SortDescendingIcon.svg');
    TMSFNCDataGrid2.Options.Filtering.Advanced := False;
    TMSFNCDataGrid2.Options.Sorting.Enabled := True;
    TMSFNCDataGrid2.RowCount := 1;
    TMSFNCDataGrid2.Stroke.Color := clDarkgray;
    TMSFNCDataGridDatabaseAdapter2.SetParentComponent(TMSFNCDataGrid2);
    TMSFNCDataGridDatabaseAdapter2.Name := 'TMSFNCDataGridDatabaseAdapter2';
    TMSFNCDataGridDatabaseAdapter2.Left := 200;
    TMSFNCDataGridDatabaseAdapter2.Top := 256;
    TMSFNCDataGridDatabaseAdapter2.Width := 26;
    TMSFNCDataGridDatabaseAdapter2.Height := 26;
    TMSFNCDataGridDatabaseAdapter2.Visible := True;
    TMSFNCDataGridDatabaseAdapter2.AutoCreateColumns := False;
    TMSFNCDataGridDatabaseAdapter2.AutoRemoveColumns := False;
    TMSFNCDataGridDatabaseAdapter2.Columns.Clear;
    with TMSFNCDataGridDatabaseAdapter2.Columns.Add do
    begin
      FieldName := 'Loadeddate';
      Header := 'Loaded Date';
      AutoCreated := False;
    end;
    with TMSFNCDataGridDatabaseAdapter2.Columns.Add do
    begin
      FieldName := 'LoadconNo';
      Header := 'Loadcon No';
      AutoCreated := False;
    end;
    with TMSFNCDataGridDatabaseAdapter2.Columns.Add do
    begin
      FieldName := 'RegNo';
      Header := 'Reg No';
      AutoCreated := False;
    end;
    with TMSFNCDataGridDatabaseAdapter2.Columns.Add do
    begin
      FieldName := 'ContractName';
      Header := 'Contract';
      AutoCreated := False;
    end;
    with TMSFNCDataGridDatabaseAdapter2.Columns.Add do
    begin
      FieldName := 'Revenue';
      Header := 'Revenue';
      AutoCreated := False;
    end;
    TMSFNCDataGridDatabaseAdapter2.DataSource := dsDetails;
    TMSFNCDataGridDatabaseAdapter2.LoadMode := almAllRecords;
    wcController.SetParentComponent(Self);
    wcController.Name := 'wcController';
    wcController.Connection := dmData.dbConnect;
    wcController.Left := 232;
    wcController.Top := 105;
    wdsController.SetParentComponent(Self);
    wdsController.Name := 'wdsController';
    wdsController.Connection := dmData.dbConnect;
    wdsController.Left := 232;
    wdsController.Top := 185;
    wdsControllerController.SetParentComponent(wdsController);
    wdsControllerController.Name := 'wdsControllerController';
    wdsControllerController.FieldName := 'Controller';
    wdsControllerTotalLoads.SetParentComponent(wdsController);
    wdsControllerTotalLoads.Name := 'wdsControllerTotalLoads';
    wdsControllerTotalLoads.FieldName := 'TotalLoads';
    wdsControllerRevenue.SetParentComponent(wdsController);
    wdsControllerRevenue.Name := 'wdsControllerRevenue';
    wdsControllerRevenue.FieldName := 'Revenue';
    wdsControllerConKey.SetParentComponent(wdsController);
    wdsControllerConKey.Name := 'wdsControllerConKey';
    wdsControllerConKey.FieldName := 'ConKey';
    dsController.SetParentComponent(Self);
    dsController.Name := 'dsController';
    dsController.AutoEdit := False;
    dsController.DataSet := wdsController;
    dsController.Left := 328;
    dsController.Top := 185;
    wcDetails.SetParentComponent(Self);
    wcDetails.Name := 'wcDetails';
    wcDetails.Connection := dmData.dbConnect;
    wcDetails.Left := 640;
    wcDetails.Top := 201;
    wdsDetails.SetParentComponent(Self);
    wdsDetails.Name := 'wdsDetails';
    wdsDetails.Connection := dmData.dbConnect;
    wdsDetails.Left := 640;
    wdsDetails.Top := 281;
    StringField1.SetParentComponent(wdsDetails);
    StringField1.Name := 'StringField1';
    StringField1.FieldName := 'Controller';
    wdsDetailsConKey.SetParentComponent(wdsDetails);
    wdsDetailsConKey.Name := 'wdsDetailsConKey';
    wdsDetailsConKey.FieldName := 'ConKey';
    wdsDetailsLoadconNo.SetParentComponent(wdsDetails);
    wdsDetailsLoadconNo.Name := 'wdsDetailsLoadconNo';
    wdsDetailsLoadconNo.FieldName := 'LoadconNo';
    wdsDetailsRegNo.SetParentComponent(wdsDetails);
    wdsDetailsRegNo.Name := 'wdsDetailsRegNo';
    wdsDetailsRegNo.FieldName := 'RegNo';
    wdsDetailsContractNo.SetParentComponent(wdsDetails);
    wdsDetailsContractNo.Name := 'wdsDetailsContractNo';
    wdsDetailsContractNo.FieldName := 'ContractNo';
    wdsDetailsContractName.SetParentComponent(wdsDetails);
    wdsDetailsContractName.Name := 'wdsDetailsContractName';
    wdsDetailsContractName.FieldName := 'ContractName';
    wdsDetailsRevenue.SetParentComponent(wdsDetails);
    wdsDetailsRevenue.Name := 'wdsDetailsRevenue';
    wdsDetailsRevenue.FieldName := 'Revenue';
    wdsDetailsLoadeddate.SetParentComponent(wdsDetails);
    wdsDetailsLoadeddate.Name := 'wdsDetailsLoadeddate';
    wdsDetailsLoadeddate.FieldName := 'Loadeddate';
    dsDetails.SetParentComponent(Self);
    dsDetails.Name := 'dsDetails';
    dsDetails.AutoEdit := False;
    dsDetails.DataSet := wdsDetails;
    dsDetails.Left := 736;
    dsDetails.Top := 281;
    DataSource1.SetParentComponent(Self);
    DataSource1.Name := 'DataSource1';
    DataSource1.DataSet := wdsDetails;
  finally
    wpTop.AfterLoadDFMValues;
    WebScrollBox1.AfterLoadDFMValues;
    wpInformation.AfterLoadDFMValues;
    TMSFNCButton1.AfterLoadDFMValues;
    wpController.AfterLoadDFMValues;
    TMSFNCDataGrid1.AfterLoadDFMValues;
    TMSFNCDataGridDatabaseAdapter1.AfterLoadDFMValues;
    TMSFNCDataGrid2.AfterLoadDFMValues;
    TMSFNCDataGridDatabaseAdapter2.AfterLoadDFMValues;
    wcController.AfterLoadDFMValues;
    wdsController.AfterLoadDFMValues;
    wdsControllerController.AfterLoadDFMValues;
    wdsControllerTotalLoads.AfterLoadDFMValues;
    wdsControllerRevenue.AfterLoadDFMValues;
    wdsControllerConKey.AfterLoadDFMValues;
    dsController.AfterLoadDFMValues;
    wcDetails.AfterLoadDFMValues;
    wdsDetails.AfterLoadDFMValues;
    StringField1.AfterLoadDFMValues;
    wdsDetailsConKey.AfterLoadDFMValues;
    wdsDetailsLoadconNo.AfterLoadDFMValues;
    wdsDetailsRegNo.AfterLoadDFMValues;
    wdsDetailsContractNo.AfterLoadDFMValues;
    wdsDetailsContractName.AfterLoadDFMValues;
    wdsDetailsRevenue.AfterLoadDFMValues;
    wdsDetailsLoadeddate.AfterLoadDFMValues;
    dsDetails.AfterLoadDFMValues;
    DataSource1.AfterLoadDFMValues;
  end;
end;

end.
